export default __webpack_public_path__ + "static/media/left-open-arrow-image.8d435aeb.svg";